import { render, staticRenderFns } from "./BarCodeReader.vue?vue&type=template&id=8942dc22&scoped=true&"
import script from "./BarCodeReader.vue?vue&type=script&lang=js&"
export * from "./BarCodeReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8942dc22",
  null
  
)

export default component.exports